import { __awaiter, __decorate, __generator, __metadata } from "tslib";
import { tryCatchHandler } from '../../base/decorators';
import { UserInfoAggregate } from '../aggregate/user-info-aggregate';
import { lockOnce } from '@tencent/ark-utils/lib/decorator/lock';
import { mergeAggregate } from '@tencent/ark-utils/lib/object';
var USER_INFO_AGGREGATE_KEY = 'mainUserInfoAggregate';
var UserInfoDomainService = /** @class */ (function () {
    function UserInfoDomainService() {
        this.userInfoAggregate = new UserInfoAggregate(USER_INFO_AGGREGATE_KEY);
        this.isInitedByBasicClientVars = false;
        mergeAggregate(this, this.userInfoAggregate, UserInfoAggregate);
        if (window.basicClientVars) {
            this.initWithBasicClientVars(window.basicClientVars);
        }
    }
    UserInfoDomainService.prototype.init = function (requestParam) {
        return __awaiter(this, void 0, void 0, function () {
            var u, resData, userInfoDomainData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        u = requestParam.u;
                        return [4 /*yield*/, this.userInfoAggregate.fetchUserInfo(1, u)];
                    case 1:
                        resData = (_a.sent()).resData;
                        userInfoDomainData = resData === null || resData === void 0 ? void 0 : resData.data;
                        if (!userInfoDomainData)
                            return [2 /*return*/];
                        this.userInfoAggregate.userInfo.initWithJsonObj({
                            avatar: userInfoDomainData.userPic,
                            nick: userInfoDomainData.nick,
                            corpId: userInfoDomainData.corpId,
                            corpName: userInfoDomainData.corpName,
                            domain: userInfoDomainData.domain,
                            domainId: userInfoDomainData.domainId,
                            loginType: userInfoDomainData.loginType,
                            login: userInfoDomainData.login,
                            uin: userInfoDomainData.uin,
                            uidSource: userInfoDomainData.uidSource,
                            wxOpenid: userInfoDomainData.wxOpenid,
                            tinyid: userInfoDomainData.tinyid,
                            userId: userInfoDomainData.userId === '' ? "p.".concat(userInfoDomainData.tinyid) : userInfoDomainData.userId,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    UserInfoDomainService.prototype.updateWithClientVars = function (clientVars) {
        if (this.isInitedByBasicClientVars) {
            return;
        }
        this.userInfoAggregate.userInfo.initWithJsonObj({
            avatar: clientVars.userPic,
            tinyid: clientVars.tinyid,
            nick: clientVars.userName,
            loginType: clientVars.userType,
            userId: clientVars.userId,
            uin: clientVars.uin,
        });
    };
    /**
     * 启动时用 window.basicClientVars 初始化.
     * 此操作理论上只做一次，后续更新都是通过user-info cgi拉取到的
     * @param basicClientVars window.basicClientVars
     */
    UserInfoDomainService.prototype.initWithBasicClientVars = function (basicClientVars) {
        this.userInfoAggregate.userInfo.initWithJsonObj({
            corpId: basicClientVars.userInfo.corpId,
            corpName: basicClientVars.userInfo.corpName,
            loginType: basicClientVars.userInfo.loginType,
            login: !!basicClientVars.userInfo.tinyId,
            uin: basicClientVars.userInfo.uin,
            uidSource: basicClientVars.userInfo.uidSource,
            wxOpenid: basicClientVars.userInfo.openId,
            tinyid: basicClientVars.userInfo.tinyId,
            userId: basicClientVars.userInfo.userId,
            avatar: basicClientVars.userInfo.userPic,
            nick: basicClientVars.userInfo.userName,
        });
        this.isInitedByBasicClientVars = true;
    };
    __decorate([
        lockOnce(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], UserInfoDomainService.prototype, "init", null);
    __decorate([
        tryCatchHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], UserInfoDomainService.prototype, "initWithBasicClientVars", null);
    return UserInfoDomainService;
}());
export { UserInfoDomainService };
